import { Col, Row } from "react-bootstrap"
import Label from "./Label"
import React from "react";

interface BaseControlProps {
    children?: React.ReactNode;
    text?: string;
    textColor?: string; // Added textColor prop
    caption?: string;
    captionColor?: string;
    contentSize?: number;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>; // Optional icon component
    enabled?: boolean; // Optional enabled state
    onClick?: () => void; // Optional click handler
}

const BaseControl: React.FC<BaseControlProps> = ({
    children=<div />,
    text="Text",
    textColor="#565656", // Use textColor instead of labelColor
    caption="",
    captionColor="#5c5c5c",
    contentSize=4,
    icon: Icon,
    enabled = true,
    onClick
}) => {
    if (textColor === "") { // Check textColor
        textColor="#565656"
    }
    if (captionColor === "") {
        captionColor="#5c5c5c"
    }
    
    const containerStyle: React.CSSProperties = {
        cursor: onClick ? (enabled ? 'pointer' : 'not-allowed') : 'default',
        opacity: enabled ? 1 : 0.5,
    };
    
    const handleClick = () => {
        if (enabled && onClick) {
            onClick();
        }
    };
    
    return <div 
        className="control-container" 
        style={containerStyle}
        onClick={handleClick}
    >
        <Row>
            <Col>
                <div style={{ display: 'flex', alignItems: 'center', gap: '' }}>
                    {Icon && (
                        <Icon
                            style={{
                                marginLeft: '10px',
                                width: '24px',
                                height: '24px',
                                fill: enabled ? '#0d6efd' : '#6c757d',
                            }}
                        />
                    )}
                    <div>
                        <Label color={textColor} fontWeight="500">{text}</Label>
                        {caption !== "" && (
                            <div>
                                <Label size="medium" fontWeight="400" color={captionColor}>{caption}</Label>
                            </div>
                        )}
                    </div>
                </div>
            </Col>
            <Col xs={contentSize} lg={contentSize}>
                <div style={{position:"absolute",right:"30px"}}>
                    {children}
                    {!enabled && (
                        <small className="badge bg-secondary" style={{ marginLeft: '8px' }}>
                            Coming Soon
                        </small>
                    )}
                </div>
            </Col>
        </Row>
    </div>
}

export default BaseControl
